var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderDraftTestCase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.438h5.414l-.137.574c-.054.246-.054.52.028.738H1.75C.766 14.75 0 13.984 0 13V2.5C0 1.543.766.75 1.75.75h4.512c.465 0 .902.191 1.23.52L9.98 3.758c.329.328.52.765.52 1.23V8.57L9.187 9.883V5.125H7a.864.864 0 0 1-.875-.875V2.062H1.75a.45.45 0 0 0-.438.438V13c0 .246.192.438.438.438zm13.262-6.235.41.41c.41.41.41 1.094 0 1.532l-.82.82-1.942-1.942.82-.82c.41-.41 1.122-.41 1.532 0zm-6.508 4.95 3.555-3.528L14 10.566l-3.555 3.528c-.11.11-.246.191-.383.246l-1.667.41c-.137.027-.301 0-.41-.11-.11-.109-.137-.273-.11-.437l.41-1.64a.86.86 0 0 1 .219-.41z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDraftTestCase);
export default __webpack_public_path__ + "static/media/folder-draft-test-case.638a74f34965f0f8c653fd2f41238cb3.svg";
export { ForwardRef as ReactComponent };